import type { ExportsFn } from '@wix/platform-editor-sdk';

import { setEditorSDK } from '../services/applicationState';
import { createEditorEventsHandlers } from './editor-events-api';
import { createPrivateAPI } from './private-api';
import { createPublicAPI } from './public-api';

export const exportsFn: ExportsFn = (editorSDK) => {
  setEditorSDK(editorSDK);
  const publicApi = createPublicAPI(editorSDK);
  return {
    public: publicApi,
    private: createPrivateAPI(editorSDK),
    editor: createEditorEventsHandlers(editorSDK, publicApi),
  };
};
